import React from "react";
import styles from "./HardwareSoftware.module.css";

const HardwareSoftware = () => {
  const hardware = [
    { name: "Arduino", icon: "🤖" },
    { name: "3D Printing", icon: "🖨️" },
    { name: "LEGO Kits", icon: "🧱" },
    { name: "Drone Tech", icon: "🚁" },
    { name: "AI", icon: "🧠" },
    { name: "Electronics & Robotic Modules", icon: "⚡" },
  ];

  const software = [
    { name: "Scratch Coding", icon: "🐱" },
    { name: "MIT App Inventor", icon: "📱" },
    { name: "Tinker CAD", icon: "✏️" },
    { name: "Pictoblox", icon: "🎮" },
    { name: "C, C++, Java, Python Projects", icon: "💻" },
    { name: "Any Programming Language", icon: "👨‍💻" },
  ];

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        <span className={styles.highlight}>IRL OPEN CATEGORY</span> HARDWARE &
        SOFTWARE TO USE
      </h2>

      <div className={styles.cardsContainer}>
        <div className={styles.card}>
          <h3>Hardware</h3>
          <div className={styles.itemsGrid}>
            {hardware.map((item, index) => (
              <div key={index} className={styles.item}>
                <span className={styles.icon}>{item.icon}</span>
                <span className={styles.name}>{item.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.card}>
          <h3>Software</h3>
          <div className={styles.itemsGrid}>
            {software.map((item, index) => (
              <div key={index} className={styles.item}>
                <span className={styles.icon}>{item.icon}</span>
                <span className={styles.name}>{item.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.note}>
        <p>
          <span className={styles.highlightOrange}>
            OPEN CATEGORY TEAMS TO ARRANGE THEIR OWN HARDWARE KITS / SOFTWARE BY
            THEMSELF
          </span>
        </p>
        <p className={styles.subtitle}>
          Note: Students can use hardware, software, or Hardware + Software
        </p>
      </div>
    </section>
  );
};

export default HardwareSoftware;
